import { ReactNode } from 'react';
import { useSubscription } from '@/hooks/useSubscription';

interface FeatureGateProps {
  feature: 'unlimitedHistory' | 'advancedInsights' | 'unlimitedTags' | 'cloudSync' | 'weeklySummaries';
  children: ReactNode;
  fallback?: ReactNode;
}

export function FeatureGate({ feature, children, fallback = null }: FeatureGateProps) {
  const { features, loading } = useSubscription();
  
  if (loading) {
    return null;
  }
  
  if (features[feature]) {
    return <>{children}</>;
  }
  
  return <>{fallback}</>;
}

// Hook for programmatic feature checking
export function useFeature(feature: keyof ReturnType<typeof useSubscription>['features']): boolean {
  const { features, loading } = useSubscription();
  
  if (loading) return false;
  
  return features[feature];
}
